import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles(() =>({
    listText: {
        color: '#393948',
        fontSize: '16px',
        fontWeight: "bold"
      }
}));